import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchResultPopup from './SearchResultPopup';
import SourceTextCache from '../new/sources/SourceTextCache';
import VersionStore from '../new/versions/VersionStore';
import './SideSearchResult.css';

export default class SideSearchResult extends Component {
    static contextTypes = {
        versions: PropTypes.instanceOf(VersionStore).isRequired
    }

    static propTypes = {
        result: PropTypes.shape({
            name: PropTypes.string.isRequired,
            shortName: PropTypes.string.isRequired
            //versions: PropTypes.arrayOf(PropTypes.shape({
                //index: PropTypes.number.isRequired,
                //versionIndex: PropTypes.number.isRequired,
                //text: PropTypes.string.isRequired
            //})).isRequired
        }).isRequired,
        resultText: PropTypes.shape({
            index: PropTypes.number.isRequired,
            versionIndex: PropTypes.number.isRequired,
            text: PropTypes.string.isRequired
        }),
        query: PropTypes.object,
        onClick: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            showPopup: false
        };
        this.onClick = this.onClick.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
    }

    onClick() {
        this.props.onClick(this.props.result);
    }

    buildVersionHtml(version, verseIndex, text) {
        //const version = this.context.versions.getVersion(verseVersion.versionIndex);
        const dummyTextCache = new SourceTextCache();
        dummyTextCache.putVerse(verseIndex, new Map([[version.getIndex(), text]]));
        const html = version.getRenderer().render(verseIndex, dummyTextCache, {
            highlightQuery: this.props.query || '',
            noInterlinearNumbers: true,
            noLexiconLookup: true
        });
        return { __html: html };
    }

    renderPopup(resultText) {
        if (!resultText) {
            return (
                <div className="SideSearchResult_Popup">
                    <div className="SideSearchResult_PopupLoading">Loading...</div>
                </div>
            );
        } else {
            const version = this.context.versions.getVersion(resultText.versionIndex);
            return (
                <div className="SideSearchResult_Popup">
                    <div className="SideSearchResult_PopupCode">{version.getCode()}</div>
                    <div dangerouslySetInnerHTML={this.buildVersionHtml(version, resultText.index, resultText.text)} />
                </div>
            );
        }
    }

    render() {
        const result = this.props.result;
        const id = `SearchResult_${result.name.replace(/[ :]/g, '')}`;
        //const version = result.versions[0];
        //const v = this.context.versions.getVersion(version.versionIndex);

        return (
            <div className="SideSearchResult" id={id} onClick={this.onClick} onMouseOver={this.showPopup} onMouseOut={this.hidePopup}>
                {result.shortName}
                {this.state.showPopup && <SearchResultPopup anchorElementId={id}>
                    {this.renderPopup(this.props.resultText)}
                </SearchResultPopup>}
            </div>
        );
    }

    showPopup() {
        this.setState({ showPopup: true });
    }

    hidePopup() {
        this.setState({ showPopup: false });
    }
}
